var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn",class:{
    loading: _vm.isLoading && !_vm.toggle,
    disabled: _vm.disabled,
    'icon-only': !_vm.action,
    'icon-right': _vm.iconRight,
    'full-width': _vm.fullWidth,
    fault: _vm.warning,
    small: _vm.small,
    toggle: _vm.toggle,
    rounded: _vm.rounded,
    active: _vm.isActive && _vm.toggle,
    center: _vm.center
  },attrs:{"disabled":_vm.disabled},on:{"click":function($event){_vm.isActive = !_vm.isActive}}},[(!_vm.iconRight)?_vm._t("default"):_vm._e(),_vm._v(" "),(_vm.action)?_c('span',[_vm._v(_vm._s(_vm.action))]):_vm._e(),_vm._v(" "),(_vm.iconRight)?_vm._t("default"):_vm._e(),_vm._v(" "),_vm._t("custom-toggle",[(_vm.toggle && !_vm.isActive && !_vm.isLoading)?_c('ck-icon',{attrs:{"name":"ico-arrow-forward-16px","fill":"grey-dark"}}):_vm._e(),_vm._v(" "),(_vm.toggle && _vm.isActive)?_c('ck-icon',{attrs:{"name":"ico-arrow-down-16px","fill":"white"}}):_vm._e()]),_vm._v(" "),(_vm.isLoading && !_vm.toggle)?_c('div',{staticClass:"lds-ring"},[_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div'),_vm._v(" "),_c('div')]):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }